const transactionType = {
  DEPOSIT: "D",
  WITDRAW: "A",
};

const cardStatus = {
  CANCELED: 0,
  PENDING: 1,
  ACTIVE: 2,
};

export { transactionType, cardStatus };
